import script from "./content-contact.vue?vue&type=script&setup=true&lang=js"
export * from "./content-contact.vue?vue&type=script&setup=true&lang=js"

import "./content-contact.vue?vue&type=style&index=0&id=90dd3f2c&lang=scss"

const __exports__ = script;

export default __exports__